<div class="row" ng-class="row.styleClass">
</div>
